// ShareButton.js
'use strict';
import { connect } from 'react-redux';

import ShareButton from '../component/ShareButton.jsx';

import pushToastr from '../action/pushToastr.js';
import setClickedShareButton from '../action/setClickedShareButton.js';
import getOperationData from '../selector/getOperationData.js';
import { ShareType } from '../hook/useShortShareLink.js';

import getShareLink from '../resource/getShareLink.js';
import { breakpoint } from '../style/variables.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import {
  ANDROID_MINIMUM_VERSION,
  SWAG_ANDROID_PACKAGE_NAME,
} from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { shareType }) => {
  const deviceWidth = getOperationData(state, ['device'], 'width');

  const swagAndroidPackageName = getRemoteConfigData(
    state,
    SWAG_ANDROID_PACKAGE_NAME
  );
  const androidMinimunVersion = getRemoteConfigData(
    state,
    ANDROID_MINIMUM_VERSION
  );
  const shareLink =
    shareType === ShareType.LIVESTREAM
      ? getShareLink({
          query: {
            link: typeof window !== 'undefined' ? window?.location?.href : null,
            afl: typeof window !== 'undefined' ? window?.location?.href : null,
            apn: swagAndroidPackageName,
            amv: androidMinimunVersion,
          },
        })
      : getShareLink();

  return {
    shareLink,
    isOnMobile: deviceWidth <= breakpoint.mobile,
  };
};

const mapDispatchToProps = (dispatch, { id }) => {
  return {
    pushToastr: data => dispatch(pushToastr(data)),
    setClickedShareButton: ({ clicked }) =>
      dispatch(setClickedShareButton({ messageId: id, clicked })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareButton);
